import { defineMessages } from 'react-intl';

export default defineMessages({
    flexProgram: {
        id: 'wmic-pe-capability-gateway-common-react.FlexProgramModal.Flex Program',
        defaultMessage: 'Flex Program',
    },
    cancelBtnLabel: {
        id: 'wmic-pe-capability-gateway-common-react.FlexProgramModal.Cancel',
        defaultMessage: 'Cancel',
    },
    requoteBtnLabel: {
        id: 'wmic-pe-capability-gateway-common-react.FlexProgramModal.Requote',
        defaultMessage: 'Requote',
    },
    flexProgramNarrative: {
        id: 'wmic-pe-capability-gateway-common-react.FlexProgramModal.The Flex Program allows...',
        defaultMessage:
            'The Flex Program allows you to modify the premium costs on some risks.',
    },
    flexRiskHeader: {
        id: 'wmic-pe-capability-gateway-common-react.FlexProgramModal.Risk #...',
        defaultMessage: 'Risk #{riskNumber}: {displayName}',
    },
    flexSaving: {
        id: 'wmic-pe-capability-gateway-common-react.Saving Quote Submission Details',
        defaultMessage: 'Saving Quote Submission Details',
    },
});
